export function scaleCount(target: number, progress: number): number {
  return progress >= 1 ? target : Math.round(target * progress);
}

export function scaleRatio(target: number, progress: number): number {
  return progress >= 1 ? target : target * progress;
}
